(function () {
  "use strict";

  var CFG = window.NL_TRACKING || {};
  if (!CFG.enabled) return;

  var STORAGE_KEY = "nl_attribution_v1";
  var QUEUE_KEY = "nl_conversion_queue_v1";
  var SESSION_ORDER_KEY = "nl_last_order_v1";

  var ATTR_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "fbclid",
    "gclid",
    "ttclid",
    "msclkid",
    "twclid",
  ];

  function readQuery() {
    var out = {};
    try {
      var q = new URLSearchParams(window.location.search);
      ATTR_KEYS.forEach(function (k) {
        var v = q.get(k);
        if (v) out[k] = v;
      });
    } catch (e) {}
    return out;
  }

  function loadAttribution() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    } catch (e) {
      return {};
    }
  }

  function saveAttribution(patch) {
    var merged = Object.assign(loadAttribution(), patch, {
      last_touch: new Date().toISOString(),
      landing_page: loadAttribution().landing_page || window.location.pathname,
    });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    } catch (e) {}
    return merged;
  }

  function getAttribution() {
    return loadAttribution();
  }

  function platformFromAttr(attr) {
    if (attr.fbclid || (attr.utm_source && /facebook|meta|fb|instagram|ig/i.test(attr.utm_source)))
      return "meta";
    if (attr.gclid || (attr.utm_source && /google|youtube|gdn/i.test(attr.utm_source)))
      return "google";
    if (attr.ttclid || (attr.utm_source && /tiktok|tt/i.test(attr.utm_source))) return "tiktok";
    if (attr.msclkid || (attr.utm_source && /bing|microsoft/i.test(attr.utm_source)))
      return "microsoft";
    if (attr.utm_source) return String(attr.utm_source).toLowerCase();
    return "direct";
  }

  function loadPixels() {
    if (CFG.meta && CFG.meta.pixelId && CFG.meta.pixelId.indexOf("YOUR_") === -1) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      window.fbq("init", CFG.meta.pixelId);
    }

    if (CFG.google && CFG.google.ga4Id && CFG.google.ga4Id.indexOf("G-XXX") === -1) {
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(CFG.google.ga4Id);
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", CFG.google.ga4Id, { send_page_view: false });
    } else if (CFG.google && CFG.google.adsId && CFG.google.adsId.indexOf("AW-XXX") === -1) {
      var s2 = document.createElement("script");
      s2.async = true;
      s2.src =
        "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(CFG.google.adsId);
      document.head.appendChild(s2);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", CFG.google.adsId, { send_page_view: false });
    }

    if (CFG.tiktok && CFG.tiktok.pixelId && CFG.tiktok.pixelId.length > 3) {
      !(function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];
        ttq.methods = [
          "page",
          "track",
          "identify",
          "instances",
          "debug",
          "on",
          "off",
          "once",
          "ready",
          "alias",
          "group",
          "enableCookie",
          "disableCookie",
        ];
        ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.instance = function (t) {
          var e = ttq._i[t] || [];
          for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
          return e;
        };
        ttq.load = function (e, n) {
          var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
          ttq._i = ttq._i || {};
          ttq._i[e] = [];
          ttq._i[e]._u = i;
          ttq._t = ttq._t || {};
          ttq._t[e] = +new Date();
          ttq._o = ttq._o || {};
          ttq._o[e] = n || {};
          var o = document.createElement("script");
          o.type = "text/javascript";
          o.async = true;
          o.src = i + "?sdkid=" + e + "&lib=" + t;
          var a = document.getElementsByTagName("script")[0];
          a.parentNode.insertBefore(o, a);
        };
        ttq.load(CFG.tiktok.pixelId);
      })(window, document, "ttq");
    }
  }

  function productPayload(extra) {
    var p = CFG.product || {};
    return Object.assign(
      {
        content_name: p.name,
        content_ids: [p.id],
        content_type: "product",
        value: p.defaultValue,
        currency: p.currency || "USD",
      },
      extra || {}
    );
  }

  function track(eventName, params) {
    var attr = getAttribution();
    var payload = Object.assign({ event_id: eventName + "_" + Date.now() }, params || {}, {
      nl_platform: platformFromAttr(attr),
      nl_utm_source: attr.utm_source || "",
      nl_utm_campaign: attr.utm_campaign || "",
    });

    if (window.fbq) {
      var fbMap = {
        PageView: "PageView",
        ViewContent: "ViewContent",
        Lead: "Lead",
        InitiateCheckout: "InitiateCheckout",
        AddToCart: "AddToCart",
        Purchase: "Purchase",
      };
      if (fbMap[eventName]) window.fbq("track", fbMap[eventName], payload);
      else window.fbq("trackCustom", eventName, payload);
    }

    if (window.gtag) {
      if (eventName === "PageView") {
        if (CFG.google.ga4Id) window.gtag("event", "page_view", payload);
      } else if (eventName === "Purchase" && CFG.google.purchaseConversionLabel) {
        window.gtag("event", "conversion", {
          send_to: CFG.google.adsId + "/" + CFG.google.purchaseConversionLabel,
          value: payload.value,
          currency: payload.currency,
          transaction_id: payload.transaction_id,
        });
        if (CFG.google.ga4Id) window.gtag("event", "purchase", payload);
      } else if (eventName === "Lead" && CFG.google.leadConversionLabel) {
        window.gtag("event", "conversion", {
          send_to: CFG.google.adsId + "/" + CFG.google.leadConversionLabel,
          value: payload.value,
          currency: payload.currency,
        });
      } else if (CFG.google.ga4Id) {
        window.gtag("event", eventName, payload);
      }
    }

    if (window.ttq) {
      var ttMap = { PageView: "PageView", InitiateCheckout: "InitiateCheckout", Purchase: "CompletePayment" };
      window.ttq.track(ttMap[eventName] || eventName, payload);
    }

    try {
      window.dispatchEvent(new CustomEvent("nl-track", { detail: { eventName, payload } }));
    } catch (e) {}
  }

  function enqueueConversion(order) {
    var list = [];
    try {
      list = JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
    } catch (e) {}
    list.push(order);
    try {
      localStorage.setItem(QUEUE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function decorateUrl(url) {
    if (!url || url.indexOf("javascript:") === 0 || url.indexOf("#") === 0) return url;
    try {
      var attr = getAttribution();
      var u = new URL(url, window.location.href);
      ATTR_KEYS.forEach(function (k) {
        if (attr[k] && !u.searchParams.has(k)) u.searchParams.set(k, attr[k]);
      });
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  function isCheckoutCta(el) {
    if (!el || el.tagName !== "A") return false;
    if (el.classList.contains("cta-button") || el.getAttribute("data-nl-track") === "cta") {
      return true;
    }
    var href = (el.getAttribute("href") || "").trim();
    if (!href) return false;
    return href.indexOf("/cart/") !== -1 || href.indexOf("checkout.html") !== -1;
  }

  function bindClicks() {
    document.querySelectorAll("a.cta-button, a[href*='/cart/']").forEach(function (a) {
      var href = a.getAttribute("href");
      if (!href || href.indexOf("javascript:") === 0 || href === "#" || href === "/") return;
      a.setAttribute("href", decorateUrl(href));
    });

    if (CFG.shopifyCheckoutUrl) {
      document.querySelectorAll("a.cta-button").forEach(function (a) {
        var href = (a.getAttribute("href") || "").trim();
        if (!href || href === "/" || href === "#" || href.indexOf("{{") !== -1) {
          a.setAttribute("href", decorateUrl(CFG.shopifyCheckoutUrl));
        }
      });
    }

    document.addEventListener(
      "click",
      function (ev) {
        var el = ev.target.closest("a");
        if (!isCheckoutCta(el)) return;
        track("InitiateCheckout", productPayload());
        track("Lead", productPayload({ content_category: "cta_click" }));
      },
      false
    );
  }

  function init() {
    var incoming = readQuery();
    if (Object.keys(incoming).length) saveAttribution(incoming);
    else if (!loadAttribution().first_visit) {
      saveAttribution({ first_visit: new Date().toISOString() });
    }

    loadPixels();
    track("PageView", productPayload());
    bindClicks();
    setTimeout(bindClicks, 300);
  }

  function recordPurchase(order) {
    var attr = getAttribution();
    var tx = order.transaction_id || "NL-" + Date.now();
    var value = order.value != null ? order.value : (CFG.product && CFG.product.defaultValue) || 27;
    var currency = order.currency || (CFG.product && CFG.product.currency) || "USD";

    var record = {
      transaction_id: tx,
      email: order.email || "",
      name: order.name || "",
      value: value,
      currency: currency,
      plan: order.plan || "",
      platform: platformFromAttr(attr),
      utm_source: attr.utm_source || "",
      utm_medium: attr.utm_medium || "",
      utm_campaign: attr.utm_campaign || "",
      fbclid: attr.fbclid || "",
      gclid: attr.gclid || "",
      created_at: new Date().toISOString(),
      uploaded_meta: false,
      uploaded_google: false,
    };

    enqueueConversion(record);
    try {
      sessionStorage.setItem(SESSION_ORDER_KEY, JSON.stringify(record));
    } catch (e) {}

    track(
      "Purchase",
      productPayload({
        transaction_id: tx,
        value: value,
        currency: currency,
      })
    );

    return record;
  }

  window.NLTracking = {
    track: track,
    getAttribution: getAttribution,
    recordPurchase: recordPurchase,
    getConversionQueue: function () {
      try {
        return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
      } catch (e) {
        return [];
      }
    },
    setConversionQueue: function (list) {
      try {
        localStorage.setItem(QUEUE_KEY, JSON.stringify(list || []));
      } catch (e) {}
    },
    getLastOrder: function () {
      try {
        return JSON.parse(sessionStorage.getItem(SESSION_ORDER_KEY) || "null");
      } catch (e) {
        return null;
      }
    },
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
